import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";

export default function Credits() {
  const { lang } = useLang();
  const [photos, setPhotos] = useState([]);
  useEffect(() => { api.get("/photos").then((r) => setPhotos(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="credits-page" style={{ background: "#F4F0E7", minHeight: "100vh" }}>
      <Seo path="/credits" lang={lang} title={lang === "ru" ? "Фото и лицензии" : "Photo credits"} description={lang === "ru" ? "Авторы фотографий и лицензии Creative Commons, используемые на сайте АРГАЛИ." : "Photographers and Creative Commons licences used on the АРГАЛИ website."} />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-32 pb-24">
        <Reveal>
          <p className="eyebrow" style={{ color: "#A96818" }}>{lang === "ru" ? "Фото и лицензии" : "Photo credits"}</p>
          <h1 className="display display-md text-argali-obsidian mt-3">{lang === "ru" ? "Авторы фотографий" : "Photography credits"}</h1>
          <p className="text-argali-brown/70 mt-5 max-w-2xl">{lang === "ru" ? "Все изображения используются в соответствии с лицензиями Creative Commons. Автор, лицензия и источник указаны для каждого снимка." : "All images are used under Creative Commons licences. Author, licence and source are listed for each photograph."}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-14">
          {photos.map((p) => (
            <div key={p.id} className="flex gap-4 border border-argali-brown/15 p-4" style={{ background: "#FAFAF7" }} data-testid={`credit-${p.id}`}>
              <img src={p.local_url} alt={p.description} className="w-24 h-24 object-cover shrink-0" loading="lazy" />
              <div className="text-sm">
                <p className="text-argali-obsidian font-medium">{p.description}</p>
                <p className="text-argali-brown/70 mt-1">{p.author}</p>
                <a href={p.license_url} target="_blank" rel="noreferrer" className="text-argali-bronze hover:underline">{p.license}</a>
                <span className="text-argali-brown/50"> · </span>
                <a href={p.source_page_url} target="_blank" rel="noreferrer" className="text-argali-bronze hover:underline">{p.source}</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
